module.exports = __webpack_public_path__ + "static/media/blur.b2acf91a.jpg";